import cplook from 'cplook'

$( ->
  # SETTINGS > MESSAGE TEMPLATES > INDEX

  ## Disables template create button until a sub-type is selected

  $('.modal.new-message-template-form .template-type.dependent-select').on 'change', ->
    submit_btn = $(this).closest('.modal.new-message-template-form').find('.submit-form')
    can_submit = !!$(this).val()
    $(submit_btn).toggleClass('disabled', !can_submit)

  $('#message_template_template_type').on('change', () ->
    handleFieldDisplay()
    handleSetEditor()
  );

  handleSetEditor = () ->
    tmceEditor = $('#message-template-body')
    if $('#message_template_template_type').val() == "sms"
      cplook.editor.tinymce_disable(tmceEditor)
      tmceEditor.data('tmcesettingskey', 'sms')
      tmceEditor.data('context', tmceEditor.data('smsContext'))
      cplook.editor.tinymce_enable(tmceEditor)
      cplook.editor.tinymce_set_content('message-template-body', $(tmceEditor.val()).text())
    else
      cplook.editor.tinymce_disable(tmceEditor)
      tmceEditor.data('tmcesettingskey', 'email')
      tmceEditor.data('context', tmceEditor.data('emailContext'))
      cplook.editor.tinymce_enable(tmceEditor)

  handleFieldDisplay = () ->
    if $('#message_template_template_type').val() == 'sms'
      $('#message_template_subject_input').hide(0)
      $('#message_template_invite').attr('checked', false).trigger('change')
      $('#message_template_invite_input').hide(0)
      $('#attachments-area').hide(0)
      $('#message_template_include_signature_input').hide(0)
      $('.tinymce.email').hide()
      $('.tinymce.sms').show()
    else
      $('#message_template_subject_input').show(0)
      $('#message_template_invite_input').show(0)
      $('#attachments-area').show(0)
      $('#message_template_include_signature_input').show(0)
      $('.tinymce.email').show()
      $('.tinymce.sms').hide()

  handleFieldDisplay()

  $('#message_template_invite, #message_template_invite_schedule').on('change', () ->
    if $('#message_template_invite').prop('checked') || $('#message_template_invite_schedule').prop('checked')
      $('#message_template_location_input').collapse('show')
    else
      $('#message_template_location_input').collapse('hide')

    if $('#message_template_invite_schedule').prop('checked')
      $('#appointment_inputs').collapse('show')
    else
      $('#appointment_inputs').collapse('hide')
  );
)
